<template>
  <div class="container text-center py-5">
    <div v-show="isLoading" class="loader-container">
      <div ref="lottieLoader" class="lottie-animation"></div>
  <p class="loader-text">Cargando...</p>
</div>
    <!-- Imagen de líneas SVG con animación -->

    <div ref="bienvenidaRef" id="album" class="card shadow-lg p-4 bg-light upload-container">
      <div class="mb-3">
        <img src="@/assets/camara.png" alt="Bienvenida" class="img-fluid gif-pequeno">
      </div>

      <h4 class="titulo">Álbum de Fotos </h4><br>

      <p class="text-muted">Sube las fotografías del evento aquí</p>

      <!-- Área de subida de fotos con diseño atractivo -->
      <label for="inputFile" class="upload-area">
        <i class="fas fa-camera-retro upload-icon"></i>
        <span class="custom-file-upload"> Selecciona imágenes</span>
      </label>

      <input 
        id="inputFile"
        ref="fileInput"
        type="file"
        name="fotos"
        class="file-input"
        accept="image/*"
        multiple
        @change="validateFiles"
      >


   

      <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>

      <!-- Vista previa de imágenes -->
      <div v-if="previewImages.length > 0" class="preview-container">
        <h5 class="text-secondary mt-3">Vista previa:</h5>
        <div class="preview-grid">
          <div v-for="(src, index) in previewImages" :key="index" class="preview-item">
            <img :src="src" alt="Vista previa" class="preview-image">
            <button class="delete-btn" @click="removeImage(index)">
              <i class="fas fa-trash-alt"></i>
            </button>
          </div>
        </div>
      </div>

  <!-- Botón personalizado -->
  <button class="upload-btn" @click="confirmUpload">
      <i class="fas fa-cloud-upload-alt"></i> Subir Fotos
    </button>
      <p class="text-muted mt-3">No olvides dar clic en "Subir fotos" después de revisar tus imágenes.</p>

      <p v-if="photoUploaded" class="mensaje-gracias">¡Gracias por compartir tus fotos con nosotros!</p>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted, nextTick } from 'vue';
import axios from 'axios';
import baseUrl from '@/api';
import Swal from 'sweetalert2';
import lottie from 'lottie-web';
import heartAnimation from '../assets/heart.json';

export default {
  name: 'hashtag-etiqueta',
  props: {
    idInvitado: {
      type: Number,
      required: true,
      validator(value) {
        return !isNaN(value) && value > 0;
      }
    },
    nombre: {
      type: String,
      default: '',
    },
    idFestejado: {
      type: Number,
      default: null,
    }
  },

  
  setup(props) {
    const errorMessage = ref('');
    const fileInput = ref(null);
    const selectedFiles = ref([]);
    const previewImages = ref([]);
    const photoUploaded = ref(false);
    const isLoading = ref(false);
    const lottieLoader = ref(null);
    const MAX_FILES = 10;
    const bienvenidaRef = ref(null);
    onMounted(() => {
  nextTick(() => {
    // Espera a que el DOM esté listo y no haya portada bloqueando
    setTimeout(() => {
      if (window.location.hash === '#album' && bienvenidaRef.value) {
        const offset = 100; // Ajusta según altura de encabezados fijos
        const top = bienvenidaRef.value.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({
          top,
          behavior: 'smooth'
        });
      }
    }, 1000); // Aumentado el delay para esperar portada
  });
});



 // ✅ Cargar Lottie SOLO cuando `isLoading` cambia a `true`
 watch(isLoading, (newVal) => {
      if (newVal && lottieLoader.value) {
        console.log("🎬 Cargando animación Lottie...");
        lottie.loadAnimation({
          container: lottieLoader.value,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          animationData: heartAnimation
        });
      }
    });

    const validateFiles = (event) => {
  const files = Array.from(event.target.files);
  
  if (files.length === 0) {
    errorMessage.value = 'Por favor, selecciona al menos una imagen.';
    return;
  }

  if (files.length > MAX_FILES) {
    Swal.fire('Límite excedido', `Solo puedes subir un máximo de ${MAX_FILES} imágenes.`, 'warning');
    event.target.value = ''; 
    return;
  }
  
  const invalidFiles = files.filter(file => !file.type.startsWith('image'));
  if (invalidFiles.length > 0) {
    errorMessage.value = 'Por favor, selecciona solo archivos de imagen (JPG, PNG, GIF).';
    event.target.value = ''; // Limpia el input
    selectedFiles.value = [];
    previewImages.value = [];
  } else {
    errorMessage.value = '';
    selectedFiles.value = files;
    previewImages.value = selectedFiles.value.map(file => URL.createObjectURL(file));
  }
};


    const removeImage = (index) => {
      selectedFiles.value.splice(index, 1);
      previewImages.value.splice(index, 1);
    };

    const confirmUpload = async () => {
      if (selectedFiles.value.length === 0) {
        errorMessage.value = 'Por favor, selecciona al menos una imagen.';
        return;
      }

      Swal.fire({
        title: 'Revisa tus fotos',
        text: 'Revisa la vista previa de las fotos antes de subirlas. Una vez que estés seguro(a), da clic en "Subir fotos".',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Subir fotos',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.isConfirmed) {
          uploadPhotos();
        }
      });
    };
    const uploadPhotos = async () => {
      console.log("🟢 Antes de activar loader:", isLoading.value);

      isLoading.value = true; // Activar el loader
      console.log("🟢 despues de activar loader:", isLoading.value);

  const formData = new FormData();
  selectedFiles.value.forEach(file => {
    formData.append('fotos', file);
  });

  formData.append('idFestejada', props.idFestejado);
  formData.append('idInvitado', props.idInvitado || null);

  // 🔍 Verificamos si las props tienen valores antes de construir la URL
  console.log("➡️ Valores recibidos en props:");
  console.log("🔹 Nombre:", props.nombre);
  console.log("🔹 idFestejado:", props.idFestejado);
  console.log("🔹 idInvitado:", props.idInvitado);

  try {
    // 🔍 Validar que los valores existan antes de armar la URL
    if (!props.nombre && !props.idFestejado && !props.idInvitado) {
      console.error(" ERROR: No se recibieron parámetros válidos.");
      return;
    }

    // 🔹 Construcción segura de la URL
    const params = [];
    if (props.nombre) params.push(encodeURIComponent(props.nombre));
    if (props.idFestejado) params.push(props.idFestejado);
    if (props.idInvitado) params.push(props.idInvitado);

    const paqueteUrl = `${baseUrl}/subirfotos/${params.join('/')}`;

    // 📌 Mostrar la URL final antes de enviar la petición
    console.log(" URL para subir fotos:", paqueteUrl);

    // 🔥 Verificamos qué se está enviando en formData
    for (let [key, value] of formData.entries()) {
      console.log(` FormData -> ${key}:`, value);
    }

    // 🔥 Hacemos la petición POST con Axios
    const response = await axios.post(paqueteUrl, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    console.log(" Respuesta del servidor:", response.data);

    if (response.data.success) {
      Swal.fire('¡Éxito!', 'Tus fotos se han subido correctamente.', 'success');
      photoUploaded.value = true;
      previewImages.value = [];
      selectedFiles.value = [];
      fileInput.value.value = '';  // Limpiar el input después de subir las fotos
    } else {
      Swal.fire('Error', 'Hubo un problema al subir las fotos.', 'error');
    }
  } catch (error) {
    console.error('Error al subir las fotos:', error);
    console.error(' Código de error:', error.code);
    console.error(' Respuesta del servidor:', error.response ? error.response.data : "No hay respuesta");

    Swal.fire('Error', 'Hubo un problema al subir las fotos.', 'error');
  }finally {
    isLoading.value = false; // Desactivar el loader después de la respuesta
  }
};



    return { 
      errorMessage, 
      fileInput, 
      confirmUpload, 
      validateFiles, 
      photoUploaded, 
      bienvenidaRef,

      previewImages, 
      removeImage ,isLoading, lottieLoader 
    };
  }
};
</script>
  
  <style scoped>
/* Contenedor Principal */
.container {
  min-height: 200px;
  height: auto;
  font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;
}
  .gif-pequeno {
    width: 50px; /* Ajusta el tamaño según tus necesidades */
    height: auto; /* Mantiene la proporción del GIF */
  }
/* Imagen Decorativa - Ajuste de Opacidad para Sutileza */
.decorative-svg {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50%; /* Ligeramente más pequeño para elegancia */
  height: auto;
  opacity: 0.6;
  pointer-events: none;
}

/* Título Ejecutivo */
.titulo {
  font-size: 1.75rem !important;
  font-weight: 700;
  color: #141414;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  margin-bottom: 2rem;
  font-family: 'hombre', sans-serif; /* Eliminamos FeelingPassionate por algo más formal */
}

/* Contenedor de Carga */
.upload-container {
  max-width: 600px;
  margin: auto;
  background: #ffffff;
  padding: 10px;
}

/* Área de subida - Estilo Dropzone Moderno */
.upload-area {
  border: 2px dashed #cbd5e1;
  background-color: #f8fafc;
  padding: 40px 20px;
  text-align: center;
  cursor: pointer;
  border-radius: 4px; /* Bordes rectos ejecutivos */
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.upload-area:hover {
  background: #f1f5f9;
  border-color: #141414;
}

/* Ícono de cámara */
.upload-icon {
  font-size: 32px;
  color: #141414;
  margin-bottom: 10px;
}

/* Texto de ayuda en la zona de subida */
.upload-area p {
  color: #64748b;
  font-size: 0.9rem;
  font-weight: 500;
}

/* Vista previa de imágenes - Grid Profesional */
.preview-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 15px;
  margin-top: 20px;
  justify-content: center;
}

.preview-item {
  position: relative;
  width: 90px;
  height: 90px;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Botón Eliminar - Minimalista */
.delete-btn {
  position: absolute;
  top: 4px;
  right: 4px;
  background:#141414;/* Usando el azul institucional */
  color: white;
  border: none;
  border-radius: 2px;
  width: 22px;
  height: 22px;
  cursor: pointer;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-btn:hover {
  background: #ef4444; /* Rojo solo en hover */
}

/* Botón de Acción Principal */
.upload-btn {
  background-color: #141414;
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 14px 24px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%; /* Botón de ancho completo para impacto */
  margin-top: 20px;
}

.upload-btn:hover {
  background-color: #0a0d2e;
  transform: translateY(-1px);
  box-shadow: 0 10px 15px -3px rgba(18, 23, 82, 0.3);
}

/* Loader de Pantalla Completa - Moderno */
.loader-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.9); /* Azul muy oscuro/negro profesional */
  backdrop-filter: blur(8px); /* Efecto cristal moderno */
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 10000;
}

.loader-text {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-family: 'Segoe UI', sans-serif;
  margin-top: 20px;
}

/* Ocultar Input de archivo pero mantener funcionalidad */
.file-input {
  display: none;
}
</style>